module.exports = __webpack_public_path__ + "static/media/SM micro-transit.57ac4aef.svg";